import { Apps } from 'src/constants/App';
import type { OrderVm } from 'src/types/OrderVm';

export function isDidiDelivery(order: OrderVm): boolean {
    return order.app === Apps.DIDI_FOOD && !order.deliverExternalOrder;
}
